<template>
  <div class="hackathon-content">
    <iframe
      v-if="getHackathonSlide"
      :src="`${getHackathonSlide.audienceUrl}?presentationId=${presentation.id}&slideId=${slideActive.id}&audienceId=${audienceId}&audienceName=${audienceName}&audienceEmoji=${audienceEmoji}&audienceTeam=${audienceQuizTeam}`"
      frameborder="0"
      class="canvas-iframe"
    />
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'

import slideTypes from '@/utils/slideTypes'

export default {
  components: {
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      slideActive: 'activeActivity',
    }),
    ...mapState({
      presentation: (state) => state.presentation,
      audienceEmoji: (state) => state.audienceEmoji,
      audienceName: (state) => state.audienceName,
      audienceId: (state) => state.audienceId,
      audienceQuizTeam: (state) => state.audienceQuizTeam,
    }),
    getHackathonSlide() {
      const index = slideTypes.findIndex((item) => item.slideType === this.slideActive.slideType)
      if (index !== -1) {
        return slideTypes[index]
      }
      return null
    },
  },
  mounted() {
    document.body.classList.add('hackathon-slide-scroll')
  },
  destroyed() {
    document.body.classList.remove('hackathon-slide-scroll')
  },
  methods: {
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";

.hackathon-content {
  height: 100%;
  padding-bottom: 136px;
}
iframe {
  width: 100%;
  height: 100%;
  border: none;
  background-color: transparent;
}

</style>
